var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-header-content"},[(_vm.art)?_c('div',{attrs:{"id":"animated-header-art"}},[_c('img',{staticClass:"lazy lazy-fade",attrs:{"data-src":_vm.art}})]):(_vm.title)?_c('h1',{staticClass:"headline text-default-5"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }